import { ActionTree } from 'vuex'
import { RootState } from '@/store/types'
import { PuntosPeligroInterface, PuntosPeligroService } from '@/domain/services/PuntosPeligroService'
import { PuntosPeligroState, StoreError } from '@/store/modules/puntos-peligro/types'

const PronosticoHidrico: PuntosPeligroInterface = new PuntosPeligroService()

export const actions: ActionTree<PuntosPeligroState, RootState> = {
  async getPuntosPeligro ({ commit }) {
    try {
      const actionResponse = await PronosticoHidrico.getPuntoPeligro()
      return commit(actionResponse.type, actionResponse.payload)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  }
}
